/* import __COLOCATED_TEMPLATE__ from './placeholder-inserter.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { placeholderPluginKey as key } from '@intercom/embercom-prosemirror-composer/lib/config/placeholder-plugin';
let PlaceholderInserter = (_class = class PlaceholderInserter extends Component {
  get composer() {
    return this.args.composer;
  }
  get node() {
    let selection = this.composer.state.prosemirrorState.selection;
    return selection?.node;
  }
  get isVisible() {
    let pluginState = key.getState(this.composer.state.prosemirrorState);
    return this.composer.state.prosemirrorState.schema.nodes.placeholder && this.node?.type === this.composer.state.prosemirrorState.schema.nodes.placeholder && pluginState.showInserter;
  }
  get activeInsertionPoint() {
    return this.composer.state.prosemirrorState.selection.$anchor;
  }
  insertBlock(block) {
    let pos = null;
    if (this.activeInsertionPoint) {
      pos = this.activeInsertionPoint.pos;
      this.args.composer.commands.insertBlockAtRange({
        from: pos,
        to: pos
      }, block);
      this.args.composer.commands.focus();
    } else {
      throw new Error('Tried to insert a block without an active insertion point');
    }
    return pos;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "insertBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertBlock"), _class.prototype)), _class);
export { PlaceholderInserter as default };